// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ut-z","tooltipWrapper":"Vt-z","icon":"Wt-z","tooltip":"Xt-z","content":"Yt-z"};